export const START_CRONJOB = 'START_CRONJOB';
export const STOP_CRONJOB = 'STOP_CRONJOB';
export const SET_CRONJOB_TIMER_ID = 'SET_CRONJOB_TIMER_ID';

export function startCronJob(id, period, doJob, timeOut) {
  return {
    type: START_CRONJOB,
    cronJob: {
      id,
      period,
      timeOut,
      doJob
    }
  };
}

export function stopCronJob(id) {
  return {
    type: STOP_CRONJOB,
    id
  };
}
